







import { Component, Vue } from 'vue-property-decorator'
@Component
export default class App extends Vue {
  drawer = false;
  created() {
    this.$vuetify.theme.dark = true
  }
}
